/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_No_SecretsInputs */

const en_rd_check_no_secrets = /** @type {(inputs: Rd_Check_No_SecretsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hardcoded secrets`)
};

const id_rd_check_no_secrets = /** @type {(inputs: Rd_Check_No_SecretsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada rahasia hardcoded`)
};

/**
* | output |
* | --- |
* | "No hardcoded secrets" |
*
* @param {Rd_Check_No_SecretsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_no_secrets = /** @type {((inputs?: Rd_Check_No_SecretsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_No_SecretsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_no_secrets(inputs)
	return en_rd_check_no_secrets(inputs)
});